import { Col, Row } from 'antd'
import { UploadMultipleImages } from 'components/atoms'
import TextArea from 'components/atoms/textArea'
import { IImageUpload } from 'interfaces'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const StyledColImg = styled(Col)`
  .upload-image {
    .ant-upload {
      width: 104px !important;
      height: 104px !important;
    }
    .ant-image {
      display: none !important;
    }
  }
`

export const StyledTitleImg = styled(Col)`
  font-weight: 600;
  margin-bottom: 6px;
`

export interface ISymptomAttachment {
  description?: string
  attachment_ids?: Array<IImageUpload>
}

interface IProps {
  preventInput?: boolean
  value?: ISymptomAttachment
  onChange?: (imgs: ISymptomAttachment, images?: Array<IImageUpload>) => void
  handleOnBlur?: (data: any) => void
}
const Symptom = (props: IProps) => {
  const { preventInput, value, onChange, handleOnBlur } = props
  const { t } = useTranslation()
  const [symptom, setSymptom] = useState('')
  const [images, setImages] = useState<Array<IImageUpload>>(
    value?.attachment_ids || []
  )
  const TOTAL_IMAGES = 4
  useEffect(() => {
    setImages(value?.attachment_ids || [])
  }, [value?.attachment_ids])

  const handleOnChange = (st?: string) => {
    if (onChange) onChange({ description: st, attachment_ids: images }, images)
  }

  const handleChangeSymptom = (e: any) => {
    setSymptom(e.target.value)
    handleOnChange(e.target.value || '')
  }

  const handleOnChangeImages = (imgs?: Array<IImageUpload>) => {
    setImages(imgs || [])
    if (onChange) onChange({ description: symptom, attachment_ids: imgs }, imgs)
  }
  let readOnly = false
  if (preventInput) {
    readOnly = true
  } else {
    readOnly = false
  }
  return (
    <Row gutter={16}>
      <Col span={12}>
        <TextArea
          required
          readOnly={readOnly}
          title={t('symptom')}
          allowClear={!preventInput}
          showCount
          value={
            value?.description === undefined ? symptom : value?.description
          }
          onBlur={() => {
            if (handleOnBlur) {
              handleOnBlur({ description: symptom, attachment_ids: images })
            }
          }}
          onChange={handleChangeSymptom}
          maxLength={1000}
          autoSize={{
            minRows: 4,
            maxRows: 4
          }}
          preventInput={preventInput}
          placeholder={t('symptom')}
        />
      </Col>
      <Col span={12}>
        <Row>
          <StyledColImg span={24}>
            <Row gutter={16}>
              <StyledTitleImg span={24}>
                {t('symptom-img', { max: 4 })}
              </StyledTitleImg>
              <UploadMultipleImages
                disabled={preventInput}
                max={TOTAL_IMAGES}
                imgs={images}
                onChange={handleOnChangeImages}
              />
            </Row>
          </StyledColImg>
        </Row>
      </Col>
    </Row>
  )
}

export default Symptom
